// import React from "react";
// import styles from "../../asset/Service/Service.module.scss";
// import WhoWeAreImage from "../../asset/homefour/serviceicon/artwork.webp";
// import WhoWeAreImage2 from "../../asset/homefour/serviceicon/digitizing.webp";
// import WhoWeAreImage3 from "../../asset/homefour/serviceicon/namedrop.webp";
// import WhoWeAreImage4 from "../../asset/homefour/serviceicon/printdesign.webp";

// const ServiceHome = () => {
//   const services = [
//     {
//       icon: WhoWeAreImage, // Replace with your icon path
//       title: "Artwork",
//     },
//     {
//       icon: WhoWeAreImage2,
//       title: "Digitizing",
//     },
//     {
//       icon: WhoWeAreImage3,
//       title: "Namedrop",
//     },
//     {
//       icon: WhoWeAreImage4,
//       title: "Print Design",
//     },
//   ];

//   return (
//     <section className={styles.serviceSection}>
//       <div className={styles.container}>
//         {services.map((service, index) => (
//           <div key={index} className={styles.card}>
//             <img src={service.icon} alt={service.title} />
//             <h3>{service.title}</h3>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default ServiceHome;

import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../asset/Service/Service.module.scss";
import WhoWeAreImage from "../../asset/homefour/serviceicon/artwork.webp";
import WhoWeAreImage2 from "../../asset/homefour/serviceicon/digitizing.webp";
import WhoWeAreImage3 from "../../asset/homefour/serviceicon/namedrop.webp";
import WhoWeAreImage4 from "../../asset/homefour/serviceicon/printdesign.webp";

const ServiceHome = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: WhoWeAreImage,
      title: "Artwork",
      hash: "#artwork",
    },
    {
      icon: WhoWeAreImage2,
      title: "Digitizing",
      hash: "#digitizing",
    },
    {
      icon: WhoWeAreImage3,
      title: "Namedrop",
      hash: "#namedrop",
    },
    {
      icon: WhoWeAreImage4,
      title: "Print Design",
      hash: "#print-design",
    },
  ];

  const handleNavigate = (hash) => {
    navigate(`/service${hash}`);
  };

  return (
    <section className={styles.serviceSection}>
      <div className={styles.container}>
        {services.map((service, index) => (
          <div
            key={index}
            className={styles.card}
            onClick={() => handleNavigate(service.hash)}
            style={{ cursor: "pointer" }}
          >
            <img src={service.icon} alt={service.title} />
            <h3>{service.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceHome;

